module.exports = __webpack_public_path__ + "img/b_intro_2_cn.9c1916d.png";